import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { MemberEntitySchema } from "@/types";
import { projectStore } from "@/hooks";
import MemberTable from "./MemberTable.vue";


/**
 * A table for managing members of a project.
 */
const __default__ = {
  name: "ProjectMemberTable",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const entity = computed(
  () =>
    ({
      entityType: "PROJECT",
      entityId: projectStore.projectId,
    }) as MemberEntitySchema
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MemberTable, { entity: entity.value }, null, 8, ["entity"]))
}
}

})